<template>
  <v-expansion-panels
    v-if="(preview && (preview != value)) || (value.length > 50)" v-bind="$attrs"
    accordion
    flat
  >
    <v-expansion-panel>
      <v-expansion-panel-title
        class="pa-0"
        style="align-items: flex-start; min-height: 24px;"
      >
        <span
          style="align-self: flex-start;"
        >
          {{ (preview) ? preview : value }}
        </span>
      </v-expansion-panel-title>
      <v-expansion-panel-text
        style="white-space: pre-wrap;"
      >
        {{ value }}
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
  <span
    v-else v-bind="$attrs"
  >
    {{ value }}
  </span>
</template>

<script>
export default {
  name: 'BaseSidebarViewerPanelValue',

  inheritAttrs: false,



  props: {
    value: {
      type: String,
      default: '',
    },
    preview: {
      type: String,
      default: '',
    },
  },
};
</script>
